export const BASEURL = "/api/v1";
export const HOMESURL = "/api/v1/homes";
export const SENIORSURL = "/api/v1/seniors";
export const FAMILYURL = "/api/v1/family_users";
export const UPLOAD_URL = "/storages/homes";
export const SENIOR_DOCUMENT = "/storages/seniors";
export const EVENTURL = "/api/v1/home_calendar_entries/";
export const MESSAGES_URL = "/api/v1/homes/messages";
export const SOCKET = "/api/v1/ws";
